import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { SubscriptionPlan } from '@vi-iot/client';

import { PLANT_OVERVIEW_COUNTRIES } from '@common';
import { BookingStore, BOOKING_PARAMS, BookingService } from '@store';

@Component({
  selector: 'app-subscription-summary',
  templateUrl: './subscription-summary.component.html',
  styleUrls: ['./subscription-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionSummaryComponent implements OnInit {
  BookingPlans = SubscriptionPlan;
  invoiceNumber: string;
  overviewUrl = 'https://heating-systems-overview.viessmann-climatesolutions.com/welcome';
  plantOverviewCountries = PLANT_OVERVIEW_COUNTRIES;

  constructor(
    public bookingStore: BookingStore,
    public bookingService: BookingService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.invoiceNumber = this.activatedRoute.snapshot.queryParams[BOOKING_PARAMS.INVOICE_NUMBER];
  }
}
